'use strict';
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dEnumeration$002dString from "./be.doeraene.webcomponents.ui5.configkeys.-Enumeration-String.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$(outer) {
  this.yi = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.yi = outer;
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$.prototype = $p;
$p.TJ = (function(value) {
  return this.yi.CK(value);
});
$p.Tt = (function(s) {
  var this$1 = $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dEnumeration$002dString.$f_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString__fromString__T__s_Option(this.yi, s);
  if (this$1.k()) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ((s + " is not a valid value for ") + this));
  } else {
    return this$1.C();
  }
});
$p.ie = (function(scalaValue) {
  return this.TJ(scalaValue);
});
$p.kR = (function(domValue) {
  return this.Tt(domValue);
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$, "be.doeraene.webcomponents.ui5.configkeys.EnumerationString$AsStringCodec$", ({
  gt: 1,
  bb: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$AsStringCodec$ };
